export default "__VITE_ASSET__a6d717a7__"